import axios from "axios";

class Payments {
    getList() {
        return axios.get('/api/v1/payments');
    }
}

export default Payments;